import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LockerCheckoutPage } from '../../components/reserve/locker-checkout/locker-checkout.page';
import { LockerSizePage } from '../../components/reserve/locker-size/locker-size.page';
import { LockerTypePage } from '../../components/reserve/locker-type/locker-type.page';
import { ReserveMainComponent } from './reserve-main.component';
import { LockerDatePage } from '../../components/reserve/locker-date/locker-date.page';
import { LockerVisorPage } from '../../components/reserve/locker-visor/locker-visor.page';
import { LocationGuard } from '../../auth/guards/location/location.guard';


const routes: Routes = [
  {
    path: 'visor', component: ReserveMainComponent,
    children: [
      { path:'',       component:LockerVisorPage }
    ]
  },
  { 
    path: ':kiosk', component: ReserveMainComponent, canActivate: [LocationGuard],
    children: [
      { path:'locker-date', component:LockerDatePage },
      { path:'locker-type', component:LockerTypePage },
      { path:'locker-size', component:LockerSizePage },
      { path:'checkout',    component:LockerCheckoutPage },
      { path:'visor',       component:LockerVisorPage }
    ]
  },
  {
    path: '**', redirectTo: 'locker/locker-location', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReserveMainPageRoutingModule {}
